/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 16/01/2014
 * Time: 16:05
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('DayView', ["$filter","$timeout","DateSrv","DayData","DaySrv",
        function ($filter,$timeout,DateSrv,DayData,DaySrv){
        //Special object fusion of Day and site->WorkingPeriodDay
        var  DayView = function(dayIndex)
        {
            this.dayIndex = -1; // index of currentVersion day
            this.dayOfWIndex = -1; // index of day (0 = monday)
            this.date = null;
            this.label = "";
            this.labelC = "";//label capitalized
            this.labelDayOfWC = "";  //Day of week capitalized
            this.datePickerOpened = false;
            this.loadDayData(dayIndex);
        }
        DayView.prototype.loadDayData = function(dayIndex)
        {
            if (dayIndex!=-1)
            {
                this.dayIndex = dayIndex;
                var day = DayData.getByIndex(dayIndex);
                if (day)
                {
                    this.dayOfWIndex = day.getDayOfWIndex();
                    this.date = day.getDate();
                    if (this.date)
                        this.label = $filter('date')(this.date, 'EEEE d MMMM');//execute angular filter
                    if (this.label.length>0)
                        this.labelC = this.label.charAt(0).toUpperCase()+  this.label.substring(1);
                    this.labelDayOfWC = DateSrv.daysOfWeekLabel[this.dayOfWIndex].charAt(0).toUpperCase() + DateSrv.daysOfWeekLabel[this.dayOfWIndex].substring(1);
                }
            }

        }
        DayView.prototype.updateCurrentDay = function(increase)
        {
            if (increase)
                this.loadDayData(this.dayIndex+1);
            else
                this.loadDayData(this.dayIndex-1);

        }

        DayView.prototype.displayTodayF = function()
        {
            this.displayDate(new Date());

        }
        DayView.prototype.displayDate = function (date) {
            if (date)
            {
                var dayId = DaySrv.getIdFromDate(date) ;
                var day = DaySrv.getByIdAdder(dayId,true);
                if (day)
                    this.loadDayData(DayData.getIndexOf(day));
            }
        }
        DayView.prototype.getModel = function()
        {
            return DayData.getByIndex(this.dayIndex);
        }

        DayView.prototype.displayDatePickerF = function ()
        {
            var dv = this;
            $timeout(function () {
                dv.datePickerOpened = true;
            });
        }

        DayView.prototype.updateFromDate = function ()
        {
            var dayId = DaySrv.getIdFromDate(this.date) ;
            var day = DaySrv.getByIdAdder(dayId,true);
            this.loadDayData(DayData.getIndexOf(day));

        }

    return  DayView;
}]);




// WEBPACK FOOTER //
// ./js/services/views/planningPos/DayView.js